import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import {
  actions as agentScannersActions,
  selectors as agentScannersSelectors
} from '~/domains/agentScanners';
import ScanCapacityBanner from './ScanCapacityBanner';

const mapStateToProps = (state) => {
  const capacity = agentScannersSelectors.agentCapacity(state);
  const dismissed = agentScannersSelectors.isCapacityBannerDismissed(state);
  const isOverCapacity =
    capacity &&
    typeof capacity.used === 'number' &&
    typeof capacity.total === 'number' &&
    capacity.used >= capacity.total;

  return {
    isVisible: Boolean(isOverCapacity) && !dismissed
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(agentScannersActions.dismissCapacityBanner())
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  context: RootStoreContext
})(ScanCapacityBanner);
